
import { useLogoutMutation } from "../Services/api";
import { useSelector, useDispatch } from 'react-redux';
import { Link, useNavigate } from "react-router-dom";
import { userLogout } from "../redux/authSlice";
import { toast } from 'react-toastify';
export default function AdminNav(props) {
    const authType = localStorage.getItem('authType');
    const navigator = useNavigate();
    const dispatch = useDispatch();
    const [logout] = useLogoutMutation();
    const logoutUser = (values) => {
        logout({ data: values })
            .unwrap()
            .then((payload) => {

                if (payload.status) {
                    const response = {
                        userDetail: null,
                        isLoggedIn: false
                    };

                    dispatch(userLogout(response));

                    if (authType === 1) {
                        navigator('/admin');
                    } else {
                        navigator('/login');
                    }

                }
            })
            .catch((error) => {
                toast.error(error.data.message)
            });

    };
    return (
        <aside id="sidebar" className="sidebar">
            <ul className="sidebar-nav" id="sidebar-nav">
                <li className="nav-item">
                    <Link to="/dashboard" className="nav-link collapsed">
                        <i className="bi bi-grid"></i>
                        <span>Dashboard</span>
                    </Link>
                </li>
                {/* <li className="nav-item">
                <Link className="nav-link collapsed" data-bs-target="#forms-nav" data-bs-toggle="collapse" to="#">
                    <i className="bi bi-journal-text"></i><span>Master Diary</span><i className="bi bi-chevron-down ms-auto"></i>
                </Link>
                <ul id="forms-nav" className="nav-content collapse " data-bs-parent="#sidebar-nav">
                    <li>
                        <Link to="/diary-list">
                            <i className="bi bi-circle"></i><span>Diary List</span>
                        </Link>
                    </li>
                    <li>
                        <Link to="/add-diary">
                            <i className="bi bi-circle"></i><span>Add Diary</span>
                        </Link>
                    </li>
                </ul>
            </li> */}
                {props['role'] == '1' ?
                    <>
                        <li className="nav-item">
                            <Link className="nav-link collapsed" data-bs-target="#manager-nav" data-bs-toggle="collapse" to="#">
                                <i className="bi bi-journal-text"></i><span>User Management</span><i className="bi bi-chevron-down ms-auto"></i>
                            </Link>
                            <ul id="manager-nav" className="nav-content collapse " data-bs-parent="#sidebar-nav">
                                <li>
                                    <Link to="/manager-list">
                                        <i className="bi bi-circle"></i><span>Trainers List</span>
                                    </Link>
                                </li>

                            </ul>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link collapsed" data-bs-target="#learner-nav" data-bs-toggle="collapse" to="#">
                                <i className="bi bi-journal-text"></i><span>Learners</span><i className="bi bi-chevron-down ms-auto"></i>
                            </Link>
                            <ul id="learner-nav" className="nav-content collapse " data-bs-parent="#sidebar-nav">
                                <li>
                                    <Link to="/learners-list">
                                        <i className="bi bi-circle"></i><span>Learners List</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/enroll-learners-information">
                                        <i className="bi bi-circle"></i><span>Enroll Learners Information </span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/enroll-review">
                                        <i className="bi bi-circle"></i><span>Review Registered Student</span>
                                    </Link>
                                </li>

                            </ul>
                        </li>
                        <li className="nav-item">
                            <Link to="/enrollment-statistics" className="nav-link collapsed">
                                <i className="bi bi-grid"></i>
                                <span>Enrollment Statistics</span>
                            </Link>
                        </li>

                        <li className="nav-item">
                            <Link to="/learner-progress" className="nav-link collapsed">
                                <i className="bi bi-grid"></i>
                                <span>Learner Progress</span>
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link collapsed" data-bs-target="#mock-exam-nav" data-bs-toggle="collapse" to="#">
                                <i className="bi bi-journal-text"></i><span>Mock Exam</span><i className="bi bi-chevron-down ms-auto"></i>
                            </Link>
                            <ul id="mock-exam-nav" className="nav-content collapse " data-bs-parent="#sidebar-nav">
                                <li>
                                    <Link to="/user-result">
                                        <i className="bi bi-circle"></i><span>User Result</span>
                                    </Link>
                                </li>
                                {/* <li>
                        <Link to="/learning-outcome-details">
                            <i className="bi bi-circle"></i><span>Learning Outcome Detail</span>
                        </Link>
                    </li> */}

                            </ul>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link collapsed" data-bs-target="#upload-course-nav" data-bs-toggle="collapse" to="#">
                                <i className="bi bi-journal-text"></i><span>Course Upload</span><i className="bi bi-chevron-down ms-auto"></i>
                            </Link>
                            <ul id="upload-course-nav" className="nav-content collapse " data-bs-parent="#sidebar-nav">
                                <li>
                                    <Link to="/learning-outcome">
                                        <i className="bi bi-circle"></i><span>Learning Outcome</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/learning-outcome-details">
                                        <i className="bi bi-circle"></i><span>Learning Outcome Detail</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/manage-resource">
                                        <i className="bi bi-circle"></i><span>Manage Resource</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/manage-qualification">
                                        <i className="bi bi-circle"></i><span>Manage Qualification </span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/manage-course">
                                        <i className="bi bi-circle"></i><span>Manage Course</span>
                                    </Link>
                                </li>
                            </ul>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link collapsed" data-bs-target="#online-exam-nav" data-bs-toggle="collapse" to="#">
                                <i className="bi bi-journal-text"></i><span>Online Exam</span><i className="bi bi-chevron-down ms-auto"></i>
                            </Link>
                            <ul id="online-exam-nav" className="nav-content collapse " data-bs-parent="#sidebar-nav">
                                <li>
                                    <Link to="/manage-exam">
                                        <i className="bi bi-circle"></i><span>Manage Exam</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/manage-module">
                                        <i className="bi bi-circle"></i><span>Manage Module</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/manage-sub-module">
                                        <i className="bi bi-circle"></i><span>Manage Sub Module</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/manage-question">
                                        <i className="bi bi-circle"></i><span>Manage Question</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/multiple-option">
                                        <i className="bi bi-circle"></i><span>Multiple Option</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/certificate-list">
                                        <i className="bi bi-circle"></i><span>Certificate list</span>
                                    </Link>
                                </li>

                            </ul>
                        </li>
                        <li className="nav-item">
                            <Link to="/messages" className="nav-link collapsed">
                                <i className="bi bi-grid"></i>
                                <span>Message</span>
                            </Link>
                        </li>
                    </>
                :
                <>
                <li className="nav-item">
                    <Link className="nav-link collapsed" data-bs-target="#discussion-nav" data-bs-toggle="collapse" to="#">
                        <i className="bi bi-journal-text"></i><span>Discussion Forum</span><i className="bi bi-chevron-down ms-auto"></i>
                    </Link>
                    <ul id="discussion-nav" className="nav-content collapse " data-bs-parent="#sidebar-nav">
                        <li>
                            <Link to="/manage-group">
                                <i className="bi bi-circle"></i><span> Group Management</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/participants-list">
                                <i className="bi bi-circle"></i><span>Participants List</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/manage-task">
                                <i className="bi bi-circle"></i><span>Task Management </span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/manage-task-question">
                                <i className="bi bi-circle"></i><span>Manage Task Question</span>
                            </Link>
                        </li>

                    </ul>
                </li>
                </> }
                
                 <li className="nav-item">
                    <Link onClickCapture={logoutUser} className="ml-4" to="#">
                        <span className="ml-4 "><b>Logout</b></span>
                    </Link>
                </li>
            </ul>
        </aside>
    );
}
